import React from 'react';
import { Button, } from 'antd';
import { useStoreState } from 'base/store';
import { ButtonType } from 'antd/lib/button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import { useRouter } from 'next/router';
import ThemeEmpty from '@base/lib/ThemeEmpty';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import { useTrans } from 'base/utils/i18n';

type CartEmptyProps = {
    className?: string;
    showGoShopping?: boolean;
    buttonType?: ButtonType
    buttonSize?: SizeType
};

const CartEmpty: React.FC<CartEmptyProps> = props => {
    const { isLogin } = useStoreState('userStore');
    const router = useRouter();
    const { t } = useTrans();
    const {
        className = '',
        showGoShopping = true,
        buttonType = 'primary',
        buttonSize = 'large',
    } = props;

    return (
        <div className={className}>
            <ThemeEmpty
                type="cart"
                tip={isLogin
                    ? t('web_cart_empty_tip')
                    : <>{t('web_cart_empty_tip')}<br/>{t('web_cart_empty_login_tip')}</>
                }
                extra={
                    <>
                        {showGoShopping && (
                            <p className="btn-wrap">
                                <Button
                                    className="btn-shopping"
                                    size={buttonSize}
                                    type={buttonType}
                                    onClick={() => router.push(RouteEnum.SHOP)}
                                >
                                    {t('web_cart_empty_btn_shopping')}
                                </Button>
                            </p>
                        )}
                        {!isLogin && !router.asPath.startsWith('/account/login') && (
                            <p className="btn-wrap">
                                <Button
                                    className="btn-login"
                                    size={buttonSize}
                                    onClick={() => router.push(generatePath(RouteEnum.LOGIN, { redirect: RouteEnum.CART }))}
                                >
                                    {t('web_common_btn_login')}
                                </Button>
                            </p>
                        )}
                    </>
                }
            />
        </div>
    )
};

export default CartEmpty;